import request from "../../Request";
import {rThen} from "../../requestThen";

export let getCountry = async () => {

    return request.get(`/api/Regions/get_countries`, false).then(r => {
        return rThen(r);
    })
}